import '../css/app.css'
import { initAds } from './ads.js'

// --- Comportements communs (navbar mobile, menus déroulants) ---
function initChrome() {
  // Menu mobile
  const mobileToggle = document.querySelector('[data-mobile-toggle]')
  const mobileMenu = document.querySelector('[data-mobile-menu]')
  if (mobileToggle && mobileMenu) {
    mobileToggle.addEventListener('click', () => mobileMenu.classList.toggle('hidden'))
  }

  // Menus déroulants génériques
  document.querySelectorAll('[data-dropdown]').forEach((dd) => {
    const toggle = dd.querySelector('[data-dropdown-toggle]')
    const menu = dd.querySelector('[data-dropdown-menu]')
    if (!toggle || !menu) return
    toggle.addEventListener('click', (e) => {
      e.stopPropagation()
      document.querySelectorAll('[data-dropdown-menu]').forEach((m) => { if (m !== menu) m.classList.add('hidden') })
      menu.classList.toggle('hidden')
    })
  })
  document.addEventListener('click', () => {
    document.querySelectorAll('[data-dropdown-menu]').forEach((m) => m.classList.add('hidden'))
  })
}

// --- Thème clair/sombre ---
// La classe `.dark` est déjà posée par le script inline du <head> (défaut = système).
// Ici : le bouton bascule et mémorise le choix ; tant qu'aucun choix explicite n'est
// mémorisé, on continue de suivre les changements de préférence système en direct.
function initTheme() {
  const root = document.documentElement
  const btn = document.getElementById('themeToggle')
  const mq = window.matchMedia('(prefers-color-scheme: dark)')

  // Applique le thème + notifie les composants qui ne réagissent pas au CSS seul (ex. la carte).
  const setDark = (dark) => {
    root.classList.toggle('dark', dark)
    document.dispatchEvent(new CustomEvent('cm:themechange', { detail: { dark } }))
  }

  btn?.addEventListener('click', () => {
    const dark = !root.classList.contains('dark')
    try { window.localStorage.setItem('theme', dark ? 'dark' : 'light') } catch (e) {}
    setDark(dark)
  })

  mq.addEventListener('change', (e) => {
    let explicit = null
    try { explicit = window.localStorage.getItem('theme') } catch (e) {}
    if (explicit !== 'dark' && explicit !== 'light') setDark(e.matches)
  })
}

// --- Consentement (CMP Google / Funding Choices) ---
// Le lien de retrait du footer n'est utile que si la CMP est effectivement chargée : elle
// arrive avec le tag AdSense, donc absente hors prod et sous bloqueur de pub. On révèle le
// bouton dès que googlefc apparaît (quelques centaines de ms après le tag), puis on abandonne.
function initConsent() {
  const btn = document.getElementById('consentManage')
  if (!btn) return

  const reopen = () => {
    const fc = window.googlefc
    if (!fc) return
    if (typeof fc.showRevocationMessage === 'function') {
      fc.showRevocationMessage()
    } else {
      fc.callbackQueue = fc.callbackQueue || []
      fc.callbackQueue.push({ CONSENT_DATA_READY: () => window.googlefc.showRevocationMessage() })
    }
  }

  let tries = 0
  const probe = window.setInterval(() => {
    if (window.googlefc) {
      btn.classList.remove('hidden')
      btn.addEventListener('click', reopen)
      window.clearInterval(probe)
    } else if (++tries > 20) {
      window.clearInterval(probe)
    }
  }, 250)
}

function boot() {
  initChrome()
  initTheme()
  initConsent()
  initAds()

  const page = document.body.dataset.page

  if (page === 'carte') {
    import('./map/index.js').then((m) => m.initMap())
  } else if (page === 'statistiques') {
    import('./stats.js').then((m) => m.initStats())
  } else if (page === 'contact') {
    import('./contact.js').then((m) => m.initContact())
  } else if (page === 'newsletter') {
    import('./newsletter.js').then((m) => m.initNewsletter())
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', boot)
} else {
  boot()
}
